// react core
import { useContext, useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";

// theming
import mainTheme from "components/main/MainTheme";
import { ThemeProvider, responsiveFontSizes } from "@mui/material/styles";

// material design
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

// fonts and icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignIn as iconConnect } from "@fortawesome/pro-thin-svg-icons";
import { faTimes as iconClose } from "@fortawesome/pro-thin-svg-icons";
import { faUser as iconUser } from "@fortawesome/pro-thin-svg-icons";
import { faCommentAltDots as iconMessaging } from "@fortawesome/pro-thin-svg-icons";

// entzy pages
import MemberProfile from "./MemberProfile";

// entzy config models and components
import configEntzy from "components/config/ConfigEntzy";
import { MainContext } from "components/main/MainContext";
import { BigButton } from "components/utils/common/CommonButtons";
import { HeaderTag } from "components/utils/common/CommonTags";
import { scrollSnapTop } from "models/Tools";

function MemberIndexPublic(props) {
  let { member } = useParams();
  const displayName = "@" + (member ? member.replace(/@/g, "") : "guest");
  return (
    <Box className="box-default">
      <Box
        className="box-default"
        sx={{
          mt: configEntzy.APP_SPACING_LG,
        }}
      >
        <HeaderTag text={displayName} bgColor="primary.main" color="black" />
        <Box
          className="box-inline"
          sx={{
            width: configEntzy.AVATAR_SIZE_LG,
          }}
        >
          <BigButton
            color="transparent"
            icon={props.drawerConnect ? iconClose : iconConnect}
            text={props.drawerConnect ? "Close" : "Connect for DMs"}
            onClick={props.drawerConnectToggle}
          />
        </Box>
      </Box>
    </Box>
  );
}

function MemberIndexConnected(props) {
  return (
    <Box className="box-default">
      <MemberProfile {...props} />
    </Box>
  );
}

function MemberIndex(props) {
  const navigate = props.navigate;

  let userConnected = props.user.connected;
  let userName = props.user.name;
  let entryPage = props.page;

  let { member } = useParams();
  let memberOverride = props.member;

  const mainContext = useContext(MainContext);

  const [memberName, setMemberName] = useState(null);
  const [notesToSelf, setNotesToSelf] = useState(false);

  const handleSetMemberName = (name) => {
    let nameClean;
    if (name && name.length > 0) {
      nameClean = name.toLowerCase();
      nameClean = nameClean.replace(/@/g, "");
      nameClean = nameClean.replace(/ /g, "_");
      nameClean = nameClean.replace(/[^a-z0-9_-]/g, "");
      setMemberName(nameClean);
      if (!mainContext.state.memberMessaging.viewer.open) {
        scrollSnapTop();
        navigate("/@/" + nameClean);
      }
    } else {
      setMemberName(null);
    }
  };
  const cbHandleSetMemberName = useCallback(handleSetMemberName, [
    navigate,
    mainContext.state.memberMessaging.viewer.open,
  ]);

  useEffect(() => {
    if (userConnected) {
      if (entryPage === "/members/me") {
        cbHandleSetMemberName(userName);
      } else if (memberOverride) {
        cbHandleSetMemberName(memberOverride);
      } else if (member) {
        cbHandleSetMemberName(member.replace(/@/g, ""));
      } else {
        cbHandleSetMemberName(null);
      }
    }
  }, [
    userConnected,
    userName,
    entryPage,
    member,
    memberOverride,
    cbHandleSetMemberName,
  ]);

  useEffect(() => {
    if (userName === memberName) {
      setNotesToSelf(true);
    } else {
      setNotesToSelf(false);
    }
  }, [userName, memberName]);

  // useEffect(() => {
  //   const matchBodyClass = () => {
  //     document.getElementById("anchor-member-area").className =
  //       "box-default " + document.body.className;
  //   };
  //   matchBodyClass();
  // }, []);

  // memberName ? (
  //   <MemberIndexConnected
  //     {...props}
  //     key={memberName}
  //     memberName={memberName}
  //     setMemberName={handleSetMemberName}
  //   />
  // ) : (
  //   <MemberIndexMenu
  //     {...props}
  //     setMemberName={handleSetMemberName}
  //   />
  // )

  return (
    <ThemeProvider theme={responsiveFontSizes(mainTheme)}>
      <Box id="anchor-member-area" className="box-default">
        <Box className="box-default">
          <Container maxWidth="md">
            {props.user.connected ? (
              <MemberIndexConnected
                {...props}
                key={memberName}
                memberName={memberName}
                setMemberName={handleSetMemberName}
              />
            ) : (
              <Box
                className="box-default"
                // sx={{
                //   pt: configEntzy.APP_SPACING_MD,
                //   pb: configEntzy.APP_SPACING_MD,
                // }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    mt: configEntzy.APP_SPACING_MD,
                  }}
                >
                  {!memberName && (
                    <FontAwesomeIcon
                      icon={iconUser}
                      transform="left-10"
                      fixedWidth
                    />
                  )}
                  <FontAwesomeIcon icon={iconMessaging} size="2x" fixedWidth />
                  {!memberName && (
                    <FontAwesomeIcon
                      icon={iconUser}
                      transform="right-10"
                      fixedWidth
                    />
                  )}
                </Typography>
                <Typography
                  variant="h6"
                  noWrap={true}
                  sx={{
                    mt: configEntzy.APP_SPACING_MD,
                  }}
                >
                  Direct Messaging
                  {notesToSelf && <span> (self)</span>}
                </Typography>
                <MemberIndexPublic {...props} />
              </Box>
            )}
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default MemberIndex;
